import React from "react";
import CustomButton from "../Shared/CustomButton/CustomButton";
import { useToastifyStore } from "../../stores/toastifyStore";
import { useLoginStateStore } from "../../stores/loginStateStore";
import { login } from "../../api/API";
import { ToastType } from "../../constants/toast";
import "./LoginContainer.css";



export default function LoginContainer() {
  const { addLoginToken } = useLoginStateStore.getState()
  const addToast = useToastifyStore(s => s.addToast);


  async function loginGame() {
    const username = (document.querySelector("#username") as HTMLInputElement).value;
    const password = (document.querySelector("#password") as HTMLInputElement).value;


    if (username === "" && password === "") {
      return addToast({ content: "Username and Password are empty", type: ToastType.warning })
    }

    if (username === "") {
      return addToast({ content: "Username is empty", type: ToastType.warning })

    }
    if (password === "") {
      return addToast({ content: "Password are empty", type: ToastType.warning })
    }

    const loginData = await login(username, password);
    if (loginData.status === "success") {
      addToast({ content: "Success", type: ToastType.success })
      setTimeout(() => {
        addLoginToken(loginData.token);
      }, 1000);
    } else {
      addToast({ content: "Error", type: ToastType.warning })
    }
  }

  return (
    <div className="login-con">
      <div className="login-left-side">
        <form className="login-form">
          <input id="username" className="login-input" placeholder="Username" type="text" />
          <input id="password" className="login-input" placeholder="Password" type="password" />
        </form>
        <div>
          <CustomButton className="login-button" onClick={loginGame} >
            <span>LOGIN</span>
          </CustomButton>
        </div>
      </div>
      <div className="login-right-side">
        <img src="./assets/images/logonew.png" alt="logo" />
      </div>
    </div>
  )
}